<template>
  <div 
    v-if="1==1"
    class="totem"
    :style="{ zoom: zoomValue}"
  >
    <div
      class="totem-body"
      :style="{ height: '900px !important' }"
    >
      <iframe-totem
        v-if="totemActiveMenu && totemActiveMenu.indexOf('ç') >= 0"
        :enterprise="mainEnterprise"
        :locale="locale"
      />
      <activity-college
        v-else-if="totemActiveMenu && totemActiveMenu === ':activityCollege'"
        :enterprise="mainEnterprise"
      />
      <Activity 
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf(':activity') >= 0"
        :enterprise="mainEnterprise"
      />
      <Meteo
        v-else-if="totemActiveMenu === ':meteo'" 
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aena'"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaLanzarote'"
        :isLanzarote="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaFuerteventura'"
        :isFuerteventura="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <item-image
        v-else-if="totemActiveMenu === ':image'"
      />
      <item-pdf
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf('pdf') >= 0"
        :enterprise="mainEnterprise"
      />
      <Webapp
        v-else-if="enterprise"
        :enterprise="enterprise"
        style="max-height: 900px !important;"
      />
      <!--Background 
        v-else-if="mainEnterprise && mainEnterprise.TotemBackground && mainEnterprise.TotemBackground.length > 0" 
        :enterpriseTotemBackground="mainEnterprise.TotemBackground"
        :enterprise="mainEnterprise"
      /-->
      <background-parrilla
        v-else-if="mainEnterprise && mainEnterprise.TotemBackground && mainEnterprise.TotemBackground.length > 0" 
        :parrilla="mainEnterprise.TotemBackground"
        :height="900"
      />
    </div>
    <TotemMainMenu 
      :enterprise="mainEnterprise" 
      :locale="locale" 
    />
  </div>
  <div 
    v-else
    class="totem"
    :style="{paddingTop: fullScreen ? 0 : isInverted ? '73px' : '680px', zoom: zoomValue}"
  >
    <messages
      v-if="fullScreen && mainEnterprise"
      :enterprise="mainEnterprise"
    />
    <screen-saver v-if="fullScreen"/>
    
    <!--totem-header 
      v-if="fullScreen && mainEnterprise"
      :enterprise="mainEnterprise"
      :locale="locale"
      :onlyBar="isInverted"
    /-->
    <header-bar
      v-if="fullScreen && mainEnterprise"
      :enterprise="mainEnterprise"
      :locale="locale"
    />
    <parrilla
      v-if="fullScreen && mainEnterprise && !isInverted"
      :parrilla="mainEnterprise.Parrilla"
    />
    <TotemMainMenu v-if="!isInverted" :enterprise="mainEnterprise" :locale="locale" />
    <div
      class="totem-body"
      :style="{ height: isInverted ? '900px !important' : null }"
    >
      <activity-college
          v-if="totemActiveMenu && totemActiveMenu === ':activityCollege'"
          :enterprise="mainEnterprise"
      />
      <Activity 
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf(':activity') >= 0"
        :enterprise="mainEnterprise"
      />
      <Meteo
        v-else-if="totemActiveMenu === ':meteo'" 
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aena'"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaLanzarote'"
        :isLanzarote="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <Aena
        v-else-if="totemActiveMenu === ':aenaFuerteventura'"
        :isFuerteventura="true"
        :locale="locale"
        :enterprise="mainEnterprise"
      />
      <item-image
        v-else-if="totemActiveMenu === ':image'"
      />
      <item-pdf
        v-else-if="totemActiveMenu && totemActiveMenu.indexOf('pdf') >= 0"
        :enterprise="mainEnterprise"
      />
      <Webapp
        v-else-if="enterprise"
        :enterprise="enterprise"
      />
      <!--Background 
        v-else-if="mainEnterprise && mainEnterprise.TotemBackground && mainEnterprise.TotemBackground.length > 0" 
        :enterpriseTotemBackground="mainEnterprise.TotemBackground"
        :enterprise="mainEnterprise"
      /-->
      <background-parrilla
        v-else-if="mainEnterprise && mainEnterprise.TotemBackground && mainEnterprise.TotemBackground.length > 0" 
        :parrilla="mainEnterprise.TotemBackground"
      />
    </div>
    <TotemMainMenu
      :enterprise="mainEnterprise" 
      :locale="locale" 
      :isInverted="true"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex'
import axios from 'axios'
import api from '@/services/api'
import utils from '@/services/utils'
import TotemMainMenu from './totemMainMenu/Index'
import Background from './Background'
import BackgroundParrilla from './BackgroundParrilla'
import Webapp from './webapp/Index'
import Activity from './Activity'
import Aena from './Aena'
import Meteo from './Meteo'
import ItemImage from './ItemImage'
import ItemPdf from './ItemPdf'
import HeaderBar from './totemHeader/HeaderBar'
import Parrilla from './totemHeader/Parrilla'
import Messages from './Messages'
import ScreenSaver from './screenSaver/Index'
import ActivityCollege from './activityCollege/Index'
import IframeTotem from './iframeTotem/Index'
export default {
  components: {
    IframeTotem,
    ScreenSaver,
    Messages,
    HeaderBar,
    //TotemHeader,
    TotemMainMenu,
    Webapp,
    Background,
    Activity,
    Aena,
    Meteo,
    ItemImage,
    ItemPdf,
    Parrilla,
    BackgroundParrilla,
    ActivityCollege,
  },
  data: () => ({
    mainEnterprise: null,
    enterprise: null,
    bgColor: 'green',
  }),
  computed: {
    ...mapState('app',['totemActiveMenu', 'totemDomain', 'locale']),
    isInverted () {
      return this.$route.query.isInverted === 'true' ? true : false
    },
    urlDomain () {
      return utils.getDomain()
    },
    zoomValue () {
      let zoom =  this.$route.query.zoom
      zoom = zoom && zoom.length > 0 ? `${zoom}% !important` : null
      return zoom
    },
    fullScreen () {
      return utils.isTotem() || this.$route.query.fullscreen === 'true' || this.$route.query.fullScreen === 'true' ? true : false
    },
    queryBGColor () {
      return this.$route.query.color ? `#${this.$route.query.color}` : null
    },
    isDev () {
      return false
      return process.env.VUE_APP_ENV === 'development' || this.$route.query.test
    },
  },
  watch: {
    'totemDomain' (v) {
      this.handleGetEnterpriseData(v)
    },
  },
  mounted () {
    this.setTotemLMD()
    this.handleGetMainEnterprise()
  },
  methods: {
    setTotemLMD () {
      try {
        const url = 'https://cm-dtouch-api.dtouch.es/v1/public/system/totemLMD'
        axios.get(url)
          .then (response => {
            if (response.data)
              this.$store.state.app.totemLMD = new Date(response.data.totemLMD)
          })
      } catch (error) {
        console.log(error)
      }
    },
    async handleGetMainEnterprise () {
      const config = await new Promise((resolve, reject) => api.getItem('enterprises', false, `totem-config/${this.urlDomain}`).then(response => { 
        resolve ({
          totemBackground: response ? response.TotemBackground : null,
          logo: response ? response.TotemLogo : null,
          totemParrilla: response ? response.TotemParrilla : null,
          totemMessage: response ? response.TotemMessage : null,
          totemCustomURLInfo: response && response.TotemCustomURLInfo ? JSON.parse(response.TotemCustomURLInfo) : null,
          totemMainMenuType: response && response.TotemMainMenuType ? response.TotemMainMenuType : 'right',
          menus: response && response.Config ? JSON.parse(response.Config) : null
        })
      }))

      api.getItem('enterprises', false, this.urlDomain).then(response => {
        if (this.isDev) response.Font = 'Roboto'
        response.Logo = config.logo
        response.Parrilla = config.totemParrilla
        response.TotemBackground = config.totemBackground
        response.TotemMessage = config.totemMessage
        response.TotemCustomURLInfo = config.totemCustomURLInfo
        response.TotemMainMenuType = config.totemMainMenuType ? config.totemMainMenuType : 'right'
        response.Menus = config.menus
        this.mainEnterprise = response  
      })
    },
    handleGetEnterpriseData (v) {
      if (!v) this.enterprise = null
      else 
        api.getItem('enterprises', false, v).then(response => {
          this.enterprise = response
          if (response.TimeZone) this.$store.state.app.TimeZone = response.TimeZone

          this.$store.state.app.totemMeteoID = response.MeteoID
          this.$store.state.app.Languages = response.Languages.split(',')
          this.$store.state.app.DefaultLocale = response.DefaultLocale ? response.DefaultLocale : 'es'
          this.$store.state.app.authType = response.AuthType && response.AuthType.length > 0 ? response.AuthType : 'none'

          this.prepareConfig(response)
        })
    },
    prepareConfig (response) {
      this.$store.state.app.dtouchWorkspace = response.ID
      this.$store.state.app.enterpriseName = response.Name
      this.$store.state.app.allergenFilters = response.AllergenFilters
      this.$store.state.app.showDishesImage = response.ShowDishesImage
      this.$store.state.app.showDishesAllergens = response.ShowDishesAllergens
      this.$store.state.app.BGColor = response.BGColor ? response.BGColor : '#56A099'
      this.$store.state.app.btnBackgroundColor = response.BtnBackgroundColor ? response.BtnBackgroundColor : ''
      this.$store.state.app.btnTextColor = response.BtnTextColor ? response.BtnTextColor : ''
      this.$store.state.app.foodDrinkTextColor = response.FoodDrinkTextColor ? response.FoodDrinkTextColor : ''
      this.$store.state.app.foodDrinkBGColor = response.FoodDrinkBGColor ? response.FoodDrinkBGColor : ''
      this.$store.state.app.foodIconRight = response.FoodIconRight

      this.$store.state.app.BGColorSecundary = response.BGColorSecundary ? response.BGColorSecundary : '#CCCCCC'
      this.$store.state.app.BGColorContent = response.BGColorContent  ? response.BGColorContent : '#FFFFFF'
      this.$store.state.app.Color = response.Color ? response.Color : '#495057'
      this.$store.state.app.ColorSecundary = response.ColorSecundary ? response.ColorSecundary : '#495057'
      this.$store.state.app.ColorContent = response.ColorContent ? response.ColorContent : '#495057'
      this.logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png';
      this.$store.state.app.Logo = response.Logo ? response.Logo : 'http://dtouch.es/assets/72c0948f-7eef-4d82-ab84-f94862c7a37f/e11a8bf0-5c3b-11e9-b777-8fe58a86ecf4.png'
      this.$store.state.app.Carousel = response.Carousel ? response.Carousel.split(',') : []
      this.$store.state.app.withGradient = response.GradientMenu  === 1 ? true : false
      this.$store.state.app.withGradientSubmenu = response.GradientSubmenu === 1 ? true : false
      this.$store.state.app.withLine = response.LineMenu === 1 ? true : false

      this.$store.state.app.GlobalFont = response.GlobalFont
      if (response.Font) this.$store.state.app.Font = response.Font
      if (response.FontSecundary) this.$store.state.app.FontSecundary = response.FontSecundary
      if (response.FontContent) this.$store.state.app.FontContent = response.FontContent

      if (response.FontSize) this.$store.state.app.FontSize = response.FontSize
      if (response.FontSizeSecundary) this.$store.state.app.FontSizeSecundary = response.FontSizeSecundary
      if (response.FontSizeContent) this.$store.state.app.FontSizeContent = response.FontSizeContent

      if (response.TextFormat) this.$store.state.app.TextFormat = response.TextFormat
      if (response.TextFormatSecundary) this.$store.state.app.TextFormatSecundary = response.TextFormatSecundary
    },
  },
}
</script>
<style >
.v-application {
  background: none !important;
}
.totem {
  height: calc(100vh);
}
.totem-body {
  height: 980px;
}
</style>
